import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 overflow-hidden" data-id="element-147">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden" data-id="element-148">
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900 to-gray-800 opacity-90" data-id="element-149"></div>
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2074&q=80')] bg-no-repeat bg-cover opacity-10" data-id="element-150"></div>
        <div className="absolute top-20 left-10 w-64 h-64 bg-amber-400/10 rounded-full blur-3xl" data-id="element-151"></div>
        <div className="absolute bottom-20 right-10 w-80 h-80 bg-red-400/10 rounded-full blur-3xl" data-id="element-152"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-153">
        <div className="py-28 md:py-40" data-id="element-154">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-155">
            <div className="text-center lg:text-left" data-id="element-156">
              <div className="inline-block px-3 py-1 text-xs font-semibold text-amber-400 bg-amber-400/10 rounded-full mb-6 backdrop-blur-sm" data-id="element-157">
                Lead Generation Experts
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight" data-id="element-158">
                Generate{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-red-400 relative" data-id="element-159">
                  High-Quality Leads
                  <svg className="absolute -bottom-2 left-0 w-full" viewBox="0 0 358 12" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-160">
                    <path d="M3 9C118.833 4.16667 252.9 -1.5 355.5 9" stroke="url(#paint0_linear)" strokeWidth="5" strokeLinecap="round" data-id="element-161" />
                    <defs data-id="element-162">
                      <linearGradient id="paint0_linear" x1="3" y1="9" x2="355.5" y2="9" gradientUnits="userSpaceOnUse" data-id="element-163">
                        <stop stopColor="#F59E0B" stopOpacity="0.5" data-id="element-164" />
                        <stop offset="1" stopColor="#EF4444" stopOpacity="0.5" data-id="element-165" />
                      </linearGradient>
                    </defs>
                  </svg>
                </span>{' '}
                That Convert
              </h1>
              <p className="mt-8 text-xl text-gray-300 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-166">
                Drive more meetings with your outbound program and keep your
                attention where it counts: pitching and closing.
              </p>
              <div className="mt-12 flex flex-col sm:flex-row gap-5 justify-center lg:justify-start" data-id="element-167">
                <a href="#contact" className="group relative px-8 py-4 bg-gradient-to-r from-amber-400 to-red-400 text-white rounded-lg font-medium text-lg hover:shadow-lg hover:shadow-amber-500/20 transition duration-300 text-center overflow-hidden" data-id="element-168">
                  <span className="relative z-10" data-id="element-169">Get Started</span>
                  <span className="absolute inset-0 bg-gradient-to-r from-amber-500 to-red-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-170"></span>
                </a>
                <a href="#services" className="group px-8 py-4 bg-white/5 backdrop-blur-sm border border-white/10 text-white rounded-lg font-medium text-lg hover:bg-white/10 transition duration-300 flex items-center justify-center" data-id="element-171">
                  Our Services
                  <ArrowRightIcon className="ml-2 h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-172" />
                </a>
              </div>
              <div className="mt-14 flex items-center justify-center lg:justify-start" data-id="element-173">
                <div className="flex -space-x-3" data-id="element-174">
                  {[1, 2, 3, 4].map(i => <img key={i} className="inline-block h-12 w-12 rounded-full ring-2 ring-white object-cover" src={`https://randomuser.me/api/portraits/men/${20 + i}.jpg`} alt="" data-id="element-175" />)}
                </div>
                <div className="ml-4" data-id="element-176">
                  <span className="text-gray-300 font-medium" data-id="element-177">
                    Trusted by{' '}
                    <span className="text-amber-400 font-semibold" data-id="element-178">500+</span>{' '}
                    businesses
                  </span>
                </div>
              </div>
            </div>
            <div className="hidden lg:block" data-id="element-179">
              <div className="bg-white/5 backdrop-blur-md p-8 rounded-2xl border border-white/10 shadow-xl relative" data-id="element-180">
                <div className="absolute -top-4 -right-4 bg-gradient-to-r from-amber-400 to-red-400 px-4 py-2 rounded-lg text-xs font-semibold text-white" data-id="element-181">
                  Free Consultation
                </div>
                <div className="text-center mb-6" data-id="element-182">
                  <h3 className="text-2xl font-bold text-white" data-id="element-183">
                    Get a Free Strategy Call
                  </h3>
                  <p className="text-gray-300 mt-2" data-id="element-184">
                    Discover how we can help you grow
                  </p>
                </div>
                <form className="space-y-5" data-id="element-185">
                  <div data-id="element-186">
                    <input type="text" placeholder="Full Name" className="w-full px-4 py-3.5 bg-white/5 border border-white/10 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-white placeholder-gray-400 transition-all" data-id="element-187" />
                  </div>
                  <div data-id="element-188">
                    <input type="email" placeholder="Business Email" className="w-full px-4 py-3.5 bg-white/5 border border-white/10 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-white placeholder-gray-400 transition-all" data-id="element-189" />
                  </div>
                  <div data-id="element-190">
                    <input type="tel" placeholder="Phone Number" className="w-full px-4 py-3.5 bg-white/5 border border-white/10 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-white placeholder-gray-400 transition-all" data-id="element-191" />
                  </div>
                  <div data-id="element-192">
                    <select className="w-full px-4 py-3.5 bg-white/5 border border-white/10 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-white placeholder-gray-400 appearance-none transition-all" data-id="element-193">
                      <option value="" className="bg-gray-900" data-id="element-194">
                        Select Industry
                      </option>
                      <option value="tech" className="bg-gray-900" data-id="element-195">
                        Technology
                      </option>
                      <option value="finance" className="bg-gray-900" data-id="element-196">
                        Finance
                      </option>
                      <option value="healthcare" className="bg-gray-900" data-id="element-197">
                        Healthcare
                      </option>
                      <option value="ecommerce" className="bg-gray-900" data-id="element-198">
                        E-commerce
                      </option>
                      <option value="other" className="bg-gray-900" data-id="element-199">
                        Other
                      </option>
                    </select>
                  </div>
                  <button type="submit" className="w-full py-4 px-4 bg-gradient-to-r from-amber-400 to-red-400 hover:from-amber-500 hover:to-red-500 text-white font-medium rounded-lg shadow-lg transition duration-300 hover:shadow-amber-500/20" data-id="element-200">
                    Schedule Your Call
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-[0]" data-id="element-201">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-[60px]" data-id="element-202">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-white" data-id="element-203"></path>
        </svg>
      </div>
    </section>;
}